import component from './zh-CN/component';
import globalHeader from './zh-CN/globalHeader';
import menu from './zh-CN/menu';
import pages from './zh-CN/pages';
import pwa from './zh-CN/pwa';
import settingDrawer from './zh-CN/settingDrawer';
import settings from './zh-CN/settings';

export default {
  'navBar.lang': '语言',
  'layout.user.link.help': '帮助',
  'layout.user.link.privacy': '隐私',
  'layout.user.link.terms': '条款',
  'app.preview.down.block': '下载此页面到本地项目',
  'app.welcome.link.fetch-blocks': '获取全部区块',
  'app.welcome.link.block-list': '基于 block 开发，快速构建标准页面',
  'app.theme.selector': '主题切换',
  'app.theme.settings': '主题设置',
  'app.theme.settings.description': '在这里选择页面主题，体验不同的色彩风格～',
  'app.theme.light': '亮色主题',
  'app.theme.light.description': '清爽白色背景，深色文字与经典蓝色按钮的对比配色。适合日间使用的明亮主题。',
  'app.theme.dark': '黑暗主题',
  'app.theme.dark.description': '深邃黑色背景，清晰白色文字与经典蓝色按钮的对比配色。适合夜间使用的深色主题。',
  'app.theme.darkOrange': '黑橙主题',
  'app.theme.darkOrange.description': '深邃黑色背景，清晰白色文字与活力橙色按钮的对比配色。个性化的暗色主题选择。',
  'app.theme.minimal': '黑白极简',
  'app.theme.minimal.description': '简洁白色背景，深色文字与纯黑按钮的极简配色。追求简约美学的主题选择。',
  'app.theme.switch.success': '主题切换成功！建议刷新页面以获得最佳体验。',
  'app.theme.reset': '跟随浏览器默认值',
  ...pages,
  ...globalHeader,
  ...menu,
  ...settingDrawer,
  ...settings,
  ...pwa,
  ...component,
};
